<template>
  <div>
    <nav-bar class="d-none d-sm-block " ref="form"/>
    <div class="primary-bg d-block d-sm-none">
      <router-link to="services">
        <v-btn
            elevation="0"
            color="secondary"
            class="rounded-lg m-2"
            @click="overlay = !overlay"
        >
          <i class="fas fa-angle-left"></i>
          <span class="white--text pr-5 ">بازگشت</span>
        </v-btn>
      </router-link>
    </div>
    <div v-if="isPageLoaded" class="container py-16 px-16 mx-auto">
      <div class="row sec-garay-bg mx-auto ">
        <div class="col-12 col-lg-4 mx-auto ">
          <img class="d-none d-sm-block mx-auto" :src="$replaceHttps(ServiceDetails.imageUrl)" width="400" height="400">
          <img class="d-block d-sm-none mx-auto" :src="$replaceHttps(ServiceDetails.imageUrl)" width="200" height="200">
        </div>
        <div class="col-12 col-lg-6 px-5 mx-auto px-5">
          <div class="font-weight-bold">  {{ ServiceDetails.productName }}</div>
          <div v-html="ServiceDetails.description"></div>
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>

import FooterMenu from "@/components/footer";
import NavBar from "@/components/navBar";


export default {
  name: "Services-details",
  components: {NavBar, FooterMenu},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-خدمات'
  },
  data: () => ({
    showLoaderDialog: false,
    isPageLoaded: false,
    ServiceDetails: {},
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getImgUrl(pic) {

      return require("../assets/img/" + pic);
    },
    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/ServiceDetails?ID=" + this.$route.query.ServiceDetailsId, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.ServiceDetails = json.service
            console.log(json)

            this.isPageLoaded = true
            this.showLoaderDialog = false;
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>